import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DeviceService } from '../../services/device.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserRoleEnum } from '../../enums/user-role-enum';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.css',
})
export class SettingsComponent implements OnInit {
  public host: string = '';
  public port: string = '';
  public settings: any;

  public caCert: string = '';
  public caCertFileName: string = '';

  public tlsCert: string = '';
  public tlsCertFileName: string = '';

  public tlsKey: string = '';
  public tlsKeyFileName: string = '';

  errorTitle: string = 'Settings Error';
  isValid: Boolean = true;
  authUser = localStorage.getItem('FLOCurrentUser');
  loginedUser = this.authUser ? JSON.parse(this.authUser) : '';
  role: any;
  constructor(
    private router: Router,
    public deviceService: DeviceService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) {}
  ngOnInit() {
    if (this.loginedUser.role !== UserRoleEnum.MasterAdmin) {
      this.router.navigateByUrl(environment.DefaultReturnUrl);
    }
    this.settings = {
      host: '',
      port: '',
      caCert: '',
      caCertFileName: '',
      tlsCert: '',
      tlsCertFileName: '',
      tlsKey: '',
      tlsKeyFileName: '',
    };
    this.getSettings();
  }
  onFileSelected(event: any, certType: string) {
    const file = event.target.files[0];
    if (file) {
      const fileName = file.name;
      const reader = new FileReader();

      reader.onload = () => {
        const fileContent = reader.result as string;

        // Store file content as text and file name based on the cert type
        switch (certType) {
          case 'caCert':
            this.caCertFileName = fileName;
            this.caCert = fileContent;
            break;
          case 'tlsCert':
            this.tlsCertFileName = fileName;
            this.tlsCert = fileContent;
            break;
          case 'tlsKey':
            this.tlsKeyFileName = fileName;
            this.tlsKey = fileContent;
            break;
          default:
            break;
        }
      };

      reader.readAsText(file); // Read the file content as text
    }
  }
  // Clears input field for each certificate
  clearFile(certType: string) {
    switch (certType) {
      case 'caCert':
        this.caCertFileName = '';
        this.caCert = '';
        break;
      case 'tlsCert':
        this.tlsCertFileName = '';
        this.tlsCert = '';
        break;
      case 'tlsKey':
        this.tlsKeyFileName = '';
        this.tlsKey = '';
        break;
      default:
        break;
    }
  }

  saveSettings() {
    //validation
    this.spinner.show();
    const hostPattern =
      /^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}|(\d{1,3}\.){3}\d{1,3}$/;
    if (!hostPattern.test(this.host)) {
      this.toastr.error('Invalid host or IP address.', this.errorTitle);
      this.isValid = false;
      this.spinner.hide();
    }

    // Port validation (must be a number between 1 and 65535)
    const portNumber = parseInt(this.port, 10);
    if (isNaN(portNumber) || portNumber < 1 || portNumber > 65535) {
      this.toastr.error(
        'Invalid port. It must be a number between 1 and 65535.',
        this.errorTitle
      );
      this.isValid = false;
      this.spinner.hide();
    }

    if (this.isValid) {
      this.settings.host = this.host;
      this.settings.port = this.port;
      this.settings.caCert = this.caCert;
      this.settings.tlsCert = this.tlsCert;
      this.settings.tlsKey = this.tlsKey;
      this.settings.caCertFileName = this.caCertFileName;
      this.settings.tlsCertFileName = this.tlsCertFileName;
      this.settings.tlsKeyFileName = this.tlsKeyFileName;
      try{
        this.deviceService.saveSettings(this.settings).subscribe(
          (response) => {
            this.toastr.success(response.message, 'Success');
            this.spinner.hide();
          },
          (error) => {
            this.toastr.error(error.error.message, this.errorTitle);
            console.log(error);
            this.spinner.hide();
          }
        );
      } catch (error){
        this.toastr.error("Internal server error", this.errorTitle);
        console.log(error);
        this.spinner.hide();
      }
    }
  }
  getSettings() {
    this.spinner.show();
    this.deviceService.getSettings().subscribe(
      (response) => {
        response.data.settings.forEach((setting: any) => {
          switch (setting.key) {
            case 'MqttHost':
              this.host = setting.value;
              break;
            case 'MqttPort':
              this.port = setting.value;
              break;
            case 'TlsKeyFileName':
              this.tlsKeyFileName = setting.value;
              break;
            case 'TlsFileName':
              this.tlsCertFileName = setting.value;
              break;
            case 'CaFileName':
              this.caCertFileName = setting.value;
              break;
            case 'TlsKey':
              this.tlsKey = setting.value;
              break;
            case 'TlsCertificate':
              this.tlsCert = setting.value;
              break;
            case 'CaCertificate':
              this.caCert = setting.value;
              break;
            default:
              console.log(`Unknown setting key: ${setting.key}`);
          }
        });
        this.spinner.hide();
      },
      (error) => {
        let errorMessage =
          typeof error.error.message === 'object'
            ? error.error.message.Text
            : error.error.message;
        this.toastr.error(errorMessage, this.errorTitle);
        console.log(error);
        this.spinner.hide();
      }
    );
  }
}
